export enum AudioIcons {
  Enabled = "primary.main",
  Disabled = "action.disabled",
  Active = "action.active",
}

export enum SnackbarColors {
  InfoStatus = "info.main",
  SuccessStatus = "success.main",
  ErrorStatus = "error.main",
  WarningStatus = "warning.main",
}

export enum TTSCustomEditorColors {
  ToolbarBackground = "#f5f5f5",
  ToolbarIconColor = "action.active",
  IconDisabledColor = "action.disabled",
  HoverColor = "action.hover",
  ToolbarActive = "rgba(0, 134, 103, 0.08)",
  ToolbarActiveBorder = "rgba(127, 201, 182, 1)",
}

export enum SSMLMenuColors {
  ActiveBackground = "rgba(0, 134, 103, 0.08)",
}

export const MenuBorderColor = "rgba(0, 0, 0, 0.23)";
export enum ContourLineGraphColors {
  GraphLine = "rgba(51, 184, 202, 1)", // #33B8CA
  Points = "rgba(40, 127, 135, 1)", // #287F87
}

export enum SSMLTagsColors {
  SayAsTag = "rgba(140, 102, 8, 1)", // #8C6608,
  BreakTag = "rgba(98, 0, 234, 1)", // #6200EA,
  // All prosody tags merged as ProsodyTag
  ProsodyTag = "rgba(0, 109, 235, 1)", // #006DEB
  EmphasisTag = "rgba(137, 137, 137, 1)", // #43A047,
  PronunciationTag = "rgba(225, 0, 225, 1)", // #898989,
  VoiceTag = "rgba(173, 20, 87, 1)", // #AD1457,
  LanguageTag = "rgba(12, 132, 117, 1)", // #00695C
  StyleTag = "rgba(0, 184, 212, 1)", // #00B8D4
}

export enum VoiceCatalogBorder {
  Default = "rgba(237, 235, 235, 1)",
  Hover = "rgba(0, 0, 0, 0.23)",
  Selected = "rgba(0, 134, 103, 0.5)",
}

export enum ListItemBackground {
  Selected = "rgba(51, 184, 202, 0.04)",
}

export enum PhonemeKeyboardChip {
  Hover = "rgba(0, 134, 103, 0.04)",
  Focused = "rgba(51, 184, 202, 0.3)",
}

export const CommonBgColor = "rgba(250, 250, 250, 1)"; // #fafafa

export const TTSWaveformColor = "rgba(0, 134, 103, 1)";
